export default __webpack_public_path__ + "static/FranklinGothic-Demi-5c2e3cdacfdee67d6c7006c62fdcc4e9.woff2";